import { useContent } from "contexts/contentContext/contentContext";
import { useEffect } from "react";
import useOrganization from "./useOrganization";

interface UseMetaI {
  currentPage: string;
}
export const useMeta = ({ currentPage }: UseMetaI) => {
  const { getMetaData, getPageText, fetchAndSetMetaData } = useContent();
  const { checkCurrDomainIsOrgDomain } = useOrganization();
  const meta = { ...(getMetaData() || {}), ...(getPageText() || {}) };
  const isOrgDomain = checkCurrDomainIsOrgDomain();

  useEffect(() => {
    fetchAndSetMetaData(currentPage, () => null);
  }, [currentPage]);

  useEffect(() => {
    if (isOrgDomain) return;
    if (meta.Browser_title) document.title = meta.Browser_title;
    if (meta.Meta_Description) updateDescription();
  }, [meta, isOrgDomain]);

  const updateDescription = () => {
    let metaDescription = document.querySelector('meta[name="description"]');

    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }

    metaDescription.setAttribute("content", meta.Meta_Description);
  };

  return null;
};
